import { render, staticRenderFns } from "./EditCatalogue.vue?vue&type=template&id=3feabf21&scoped=true&"
import script from "./EditCatalogue.vue?vue&type=script&lang=js&"
export * from "./EditCatalogue.vue?vue&type=script&lang=js&"
import style0 from "./EditCatalogue.vue?vue&type=style&index=0&id=3feabf21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feabf21",
  null
  
)

export default component.exports